import moment from 'moment-timezone'
export default function () {
  return {
    dateRange: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    },
    accountEntries: [],
    gateCampingReport: [],
    gateParkingReport: [],
    campgroundReport: [],
    campsiteReport: [],
    parkingReport: [],
    gatePassReport: [],
    invoiceSourceReport: [],
    generatedReport: [],
    errorLog: []
  }
}
